import classNames from 'classnames';
import React from 'react';

import PlaceholderImage from '@Images/placeholder.png';
import { getColorByLetter } from '@Utils/colors';
import { getFirstLetter } from '@Utils/string';

import styles from './UserAvatar.module.scss';

export interface UserAvatarProps {
  name?: string;
  size?: number;
  nofill?: boolean;
  className?: string;
  thumbnail?: string;
}
interface TextStyle {
  lineHeight: string;
  fontSize: string;
  color: string;
}

const renderAvatarIcon = (elementTextStyle: TextStyle) => {
  return (
    <span style={elementTextStyle}>
      <svg
        fill={elementTextStyle.color}
        height={elementTextStyle.fontSize}
        viewBox="0 0 24 24"
        width={elementTextStyle.fontSize}
      >
        <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
        <path d="M0 0h24v24H0z" fill="none" />
      </svg>
    </span>
  );
};

const UserAvatar: React.FunctionComponent<UserAvatarProps> = ({
  name,
  size = 40,
  nofill = false,
  className,
  thumbnail,
}) => {
  const elementTextStyle: TextStyle = {
    lineHeight: `${size}px`,
    fontSize: `${(size * 24) / 40}px`,
    color: nofill ? '#4CAF50' : '#fff',
  };

  const elementStyle = {
    backgroundColor: nofill ? '#fff' : getColorByLetter(getFirstLetter(name)),
    width: `${size}px`,
    height: `${size}px`,
  };

  const body = name ? <div style={elementTextStyle}>{getFirstLetter(name)}</div> : renderAvatarIcon(elementTextStyle);
  const expertPicture = thumbnail || null;

  return (
    <div
      className={classNames(styles.avatar, { [styles.nofill]: nofill }, className)}
      style={elementStyle}
      aria-label={name}
    >
      {thumbnail ? (
        <img
          alt={name}
          src={expertPicture || PlaceholderImage}
          className={classNames(styles.avatar, { [styles.nofill]: nofill }, className)}
        />
      ) : (
        body
      )}
    </div>
  );
};

export default UserAvatar;
